import { ReactElement } from 'react';
import { createPortal } from 'react-dom';

export type MaybeTeleportProps = {
    children: ReactElement;
    portal?: Element | null;
    teleport: boolean;
};

export const MaybeTeleport = ({ children, portal, teleport }: MaybeTeleportProps) => {
    if (portal && teleport) {
        return createPortal(children, portal);
    }
    return children;
};
